export default __webpack_public_path__ + "static/media/seatings.ca106593.png";